import { injectIntl } from 'react-intl';
import ClientRedirectNew from './ClientRedirectNew';
import config from './config';

export const CONFIG = config;

export default injectIntl(ClientRedirectNew);
